import copyHandler from './copyHandler';
import pasteHandler from './pasteHandler';

function addCopyPasteListeners() {
  document.addEventListener('copy', copyHandler);

  document.addEventListener('paste', pasteHandler);
}

export default addCopyPasteListeners;
